import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookies from 'js-cookie';
import {
    handleCheckIsMasterCardMember
} from '../helpers/toch-helpers';
import * as upgradeAccountActions from '../../../sso/store/actions/upgrade-account-actions';
import MastercardRegistrationForm from './MasterCardRegistrationForm';
import MastercardRegistrationSuccess from './MasterCardRegistrationSuccess';
import { isEmpty } from '../../../sso/components/utils/obj-utils';
import AudioComponent from '../helpers/AudioComponent';
import userService from '../../../../general/js/user/user-service';
import { CookieNames } from '../../../../general/js/utils/cookies';
import { MembershipTypes } from '../../../../general/js/utils';

class MastercardRegistration extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            masterCardNumber: '',
            name: '',
            postcode: '',
            isMasterCardNumber: true,
            isDataSent: false,
            formHasErrors: false,
            isModalOpen: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleOnChangeFocus = this.handleOnChangeFocus.bind(this);
        this.getUserFirstName = this.getUserFirstName.bind(this);
        this.displayMasterCardRegister = this.displayMasterCardRegister.bind(this);
        this.playSound = this.playSound.bind(this);
        this.updateDataInLocalStorage = this.updateDataInLocalStorage.bind(this);
    }

    handleChange(e, fieldName) {
        this.setState({ [fieldName]: e.target.value });
    }

    playSound() {
        const audio = document.getElementById('audio');
        audio.play();
    }

    updateDataInLocalStorage() {
        const localStorageData = userService.getDataFromLocalStorage(CookieNames.TOCH_USER_MEMBERSHIPS);
        const newLocalStorageData = JSON.parse(localStorageData) + ';' + MembershipTypes.OneClubAdvantage;

        userService.setTOCHUserMembershipsInLocalStorage(JSON.stringify(newLocalStorageData));
    }

    handleOnChangeFocus(e) {
        const { regexToVerifyMastercard } = this.props.options;
        const regexExpression = new RegExp(regexToVerifyMastercard);
        const regexToVerifyOnlyDigits = /^\d+$/;

        if (regexExpression.test(e.target.value) && regexToVerifyOnlyDigits.test(e.target.value) && e.target.value.length === 16) {
            this.setState({ isMasterCardNumber: true });
        } else { this.setState({ isMasterCardNumber: false }); }
    }

    onSubmit = (e) => {
        e.preventDefault();

        const { isMasterCardNumber } = this.state;
        const { callbackUrl } = this.props.options;
        const { actions } = this.props;

        if (isMasterCardNumber) {
            actions.addMasterCardMembershipToUser(callbackUrl).then(() => {
                this.playSound();
                this.setState({ isDataSent: true });
                this.updateDataInLocalStorage();
            }).catch((error) => {
                this.setState({ formHasErrors: true });
                console.error(error);
            });
        } else {
            this.setState({ isMasterCardNumber: false });
        }
    }

    getUserFirstName() {
        const cookieValue = Cookies.get(CookieNames.TOCH_USER_DATA);
        const cookie = !isEmpty(cookieValue) ? JSON.parse(cookieValue) : null;

        return cookie != null ? cookie.firstName : null;
    }

    displayMasterCardRegister() {
        const {
            backgroundImage,
            masterCardLogo,
            masterCardText,
            masterCardNumberLabel,
            nameLabel,
            title,
            bottomInfo,
            postcodeLabel,
            ctaSignUpForMastercardLink,
            notMasterCardNumberErrorMessage,
            masterCardRegistrationSuccessTitle,
            masterCardRegistrationSuccessLabel,
            masterCardRegistrationSuccessDescription,
            masterCardRegistrationSuccessCTALink,
            soundToBePlayedAfterSuccessRegister
        } = this.props.options;
        const { isMasterCardNumber, isDataSent } = this.state;

        const userFirstName = this.getUserFirstName();

        return (
            <div>
                <div>
                    <AudioComponent
                        soundToBePlayedAfterSuccessRegister={soundToBePlayedAfterSuccessRegister}>
                    </AudioComponent>
                </div>
                <div>
                    {
                        isDataSent ?
                            <MastercardRegistrationSuccess
                                masterCardRegistrationSuccessTitle={masterCardRegistrationSuccessTitle}
                                masterCardRegistrationSuccessLabel={masterCardRegistrationSuccessLabel}
                                masterCardRegistrationSuccessDescription={masterCardRegistrationSuccessDescription}
                                masterCardRegistrationSuccessCTALink={masterCardRegistrationSuccessCTALink}
                                masterCardText={masterCardText}
                                masterCardLogo={masterCardLogo}
                                firstName={userFirstName}
                            ></MastercardRegistrationSuccess> :
                            <MastercardRegistrationForm
                                backgroundImage={backgroundImage}
                                masterCardLogo={masterCardLogo}
                                masterCardText={masterCardText}
                                masterCardNumberLabel={masterCardNumberLabel}
                                nameLabel={nameLabel}
                                title={title}
                                bottomInfo={bottomInfo}
                                postcodeLabel={postcodeLabel}
                                ctaSignUpForMastercardLink={ctaSignUpForMastercardLink}
                                notMasterCardNumberErrorMessage={notMasterCardNumberErrorMessage}
                                isMasterCardNumber={isMasterCardNumber}
                                handleChange={this.handleChange}
                                handleOnChangeFocus={this.handleOnChangeFocus}
                                onSubmit={this.onSubmit}
                            ></MastercardRegistrationForm>
                    }
                </div>
            </div>
        );
    }

    render() {
        const isMasterCardMember = handleCheckIsMasterCardMember(CookieNames.TOCH_USER_MEMBERSHIPS);

        return (
            !isMasterCardMember ?
                this.displayMasterCardRegister() : null
        );
    }
}

function mapStateToProps() {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            addMasterCardMembershipToUser: bindActionCreators(upgradeAccountActions.addMasterCardMembershipToUser, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MastercardRegistration);
